// removed by extract-text-webpack-plugin
module.exports = {"container":"container__372gh","error":"error__2sbyk","icon":"icon__2jc1Q","message":"message__3Nt5l","info":"info__RXyn3","success":"success__KM_-3"};


//////////////////
// WEBPACK FOOTER
// ./components/inlineMessage/inlineMessage.css
// module id = bdl5
// module chunks = 0